import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Box, } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { navStore, useStore } from '@mcn-platform/models';
const limitToPageWidth = true;
const Membership = ({ membershipID, modifiers }) => {
    const [member, setMember] = useState();
    const store = useStore();
    // const { currentCustomer, currentMembers } = store;
    const membership = membershipID ? store.getOrLoad('membership', membershipID) : undefined;
    console.log('modifiers', modifiers);
    // console.log('currentMembers', currentMembers);
    let action = 'view';
    if (modifiers && modifiers.length >= 2) {
        [, action] = modifiers;
    }
    useEffect(() => {
        const startCheckout = async () => {
            console.log('show dialog');
            navStore.showBlockInput();
            const response = await store.startCheckout([{ type: 'membership', id: membershipID }], '');
            console.log('response', response);
            if (response.statusCode === 200 && response.checkoutUrl) {
                setMember(response.member);
                window.location = response.checkoutUrl;
            }
            else if (response.statusCode !== 400) {
                console.log('Already a member');
                setMember(response.member);
            }
            navStore.clearBlockInput();
        };
        if (action === 'checkout' && !member) {
            // check if customer already a member
            // const membershipFound = currentMembers.find((m) => (m.membershipID === membershipID));
            // if (membershipFound) {
            //   console.log('already have membership, skipping checkout', membershipFound);
            // } else {
            startCheckout().then(() => console.log('all done'));
            // }
        }
    }, [store, action, member, membershipID]);
    // if (!currentCustomer) {
    //   return (
    //     <Box
    //       sx={{
    //         ...(limitToPageWidth && {
    //           width: '100%',
    //           maxWidth: 1200,
    //           marginX: 'auto',
    //         }),
    //       }}
    //     >
    //       <Box sx={{ m: 4 }}>Please log-in</Box>
    //     </Box>
    //   );
    // }
    if (!membership) {
        return null;
    }
    return (_jsxs(Box, { sx: {
            ...(limitToPageWidth && {
                width: '100%',
                maxWidth: 1200,
                marginX: 'auto',
            }),
        }, children: [_jsx("h1", { children: membership.name }), _jsx("h2", { children: membership.summary() }), member && (_jsx("div", { children: "You are already a member." }))] }));
};
Membership.defaultProps = {};
Membership.meta = {
    group: 'hidden',
    name: 'Membership Details',
    description: 'Show detailed information on a customer membership.',
    props: [
        {
            key: 'membershipID',
            name: 'Membership',
            type: 'membership', // note this is a special type recognized by the system
            description: 'The membership record to display.',
        },
        {
            key: 'modifiers',
            name: 'Modifiers',
            type: 'modifiers', // note this is a special type recognized by the system
            description: 'Details on action to take.',
        },
    ],
    defaultConfig: {
        type: 'component',
        component: 'Membership',
        props: {
            props: {
                membershipID: '@membershipID',
                modifiers: 'view',
            },
        },
    },
};
export default observer(Membership);
//# sourceMappingURL=Membership.js.map